export default {
  employees: [],
  employeeIds: [],
  balanceIds: []
};
